export const ASSIGN_BABY_COUNT = 'ASSIGN_BABY_COUNT';
export const SET_INVITE_TOKEN = 'SET_INVITE_TOKEN';

export function assignBabyCount(count) {
  return { type: ASSIGN_BABY_COUNT, payload: count };
}

export function setInviteToken(token) {
  return { type: SET_INVITE_TOKEN, token };
}
